import React from 'react';
import styles from './WordCloud.module.css';

export default function WordCloud({ data }) {
    if (!data?.length) return (
        <p style={{ color: 'var(--text-secondary)', textAlign: 'center', padding: '40px 0' }}>
            لا توجد تصنيفات فرعية مرتبطة باحتجاجات بعد
        </p>
    );

    const max = data[0]?.count || 1;
    const min = data[data.length - 1]?.count || 1;
    const range = max - min || 1;

    const fontSize = (count) => {
        const ratio = (count - min) / range;
        return Math.round(13 + ratio * 26);
    };

    const opacity = (count) => {
        const ratio = (count - min) / range;
        return +(0.55 + ratio * 0.45).toFixed(2);
    };

    // shuffle slightly so it doesn't look like a sorted list
    const shuffled = [...data].sort(() => Math.random() - 0.48);

    return (
        <div className={styles.cloud}>
            {shuffled.map((item, idx) => (
                <span
                    key={idx}
                    className={styles.tag}
                    style={{
                        fontSize: `${fontSize(item.count)}px`,
                        opacity: opacity(item.count),
                    }}
                    title={`${item.text} — ${item.count} ${item.count === 1 ? 'احتجاج' : 'احتجاجات'}`}
                >
                    {item.text}
                </span>
            ))}
        </div>
    );
}
